import { Injectable } from '@angular/core';
import {
  GetOperatorRevenueResponse,
  GetOperatorRevenueRequest,
} from 'app/models/operator/get-operator-revenue';
import {
  GetOperatorOnlineDriversResponse,
  GetOperatorOnlineDriversRequest,
} from 'app/models/operator/get-operator-online-drivers';
import {
  GetOperatorDashboardStatisticsRequest,
  GetOperatorDashboardStatisticsResponse,
} from 'app/models/operator/get-operator-dashboard-statistics';

import { ApiHttp } from 'app/providers';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class OperatorDashboardService {
  private apiRoot = `api/AdminXpressOperatorDashboard`;
  constructor(private apiHttp: ApiHttp) {}

  public getOperatorRevenue(
    request: GetOperatorRevenueRequest,
    messageService: MessageService
  ): Promise<GetOperatorRevenueResponse> {
    return this.apiHttp.post(
      `${this.apiRoot}/GetOperatorRevenue`,
      request,
      messageService
    );
  }

  public getOperatorOnlineDrivers(
    request: GetOperatorOnlineDriversRequest,
    messageService: MessageService
  ): Promise<GetOperatorOnlineDriversResponse> {
    return this.apiHttp.post(
      `${this.apiRoot}/GetOperatorOnlineDrivers`,
      request,
      messageService
    );
  }

  public getOperatorRiderStatistics(
    request: GetOperatorDashboardStatisticsRequest,
    messageService: MessageService
  ): Promise<GetOperatorDashboardStatisticsResponse> {
    return this.apiHttp.post(
      `${this.apiRoot}/GetOperatorRiderStatistics`,
      request,
      messageService
    );
  }
}
